class ReviewsCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
    this.store = this.dataset.store;
    this.skus = this.dataset.skus;
    this.reviewLimit = this.dataset.reviewLimit;
    this.i18n = {
      verified_buyer: this.dataset.i18nVerifiedBuyer || "Verified Buyer"
    };
  }

  connectedCallback() {
    if (this.dataset.reviewProvider) {
      if (this.store) {
        this.getReviews();
      } else {
        this.style.display = "none";
      }
    } else {
      this.addCarouselParameters();
    }
  }

  async getReviews() {
    await fetch(`https://api.reviews.io/product/review?store=${this.store.replace("https://", "")}&sku=${this.skus}`)
      .then(response => response.json())
      .then(data => {
        if (data.reviews.data.length === 0) {
          this.style.display = "none";
        } else {
          this.populateProductReviews(data);
        }
      })
      .catch(error => console.error("Error fetching reviews:", error))
      .finally(() => {});
  }

  populateProductReviews(data) {
    data.reviews.data.forEach(review_data => {
      const review = document.createElement("swiper-slide");
      review.innerHTML = `
          <div class="review-card">
            <div class="star-rating"><span class="star-rating__rating" style="--rating:${review_data.rating * 20}%">★★★★★</span></div>
            <blockquote class="review-card__content">
              <p class="p1">${review_data.review}</p>
              <cite class="review-card__author p2">${review_data.reviewer.first_name} ${review_data.reviewer.last_name}</cite>
            </blockquote>
            ${
              review_data.reviewer.verified_buyer
                ? `
              <div class="verified-buyer review-card__verified-buyer">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 17 16">
                  <g clip-path="url(#a)">
                    <path fill="#95A681" d="M16.723 8c0 .864-1.05 1.517-1.306 2.286-.256.793.187 1.96-.28 2.613-.49.676-1.726.606-2.402 1.073-.653.49-.98 1.702-1.773 1.959-.77.256-1.726-.537-2.589-.537s-1.819.793-2.589.537c-.793-.257-1.12-1.47-1.772-1.96-.677-.49-1.913-.42-2.403-1.072-.49-.653-.023-1.82-.28-2.613C1.074 9.516.024 8.84.024 8.001c0-.84 1.05-1.516 1.307-2.286.256-.793-.187-1.96.28-2.612.49-.677 1.725-.607 2.402-1.073.653-.49.98-1.703 1.772-1.96.77-.256 1.726.537 2.59.537.862 0 1.819-.793 2.588-.536.793.256 1.12 1.469 1.773 1.959.676.49 1.912.42 2.402 1.073.49.653.024 1.819.28 2.612.257.77 1.306 1.446 1.306 2.286Z"/>
                    <path stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width=".91" d="m5.271 8 2.17 2.053 3.988-4.222"/>
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h16.723v16H0z"/>
                    </clipPath>
                  </defs>
                </svg>
                <span>${this.i18n.verified_buyer}</span>
              </div>
            `
                : ""
            }
            ${
              review_data.product.name
                ? `
              <a href="" class="review-card__product">
                <div class="review-card__product-media">
                  <img src="${review_data.product.image_url}" alt="${review_data.product.name}" class="lazyload" data-src="${review_data.product.image_url}" />
                </div>
                <div class="review-card__product-content">
                  <h3 class="">${review_data.product.name}</h3>
                    <p class="t-short uppercase">
                      ${review_data.product.category}
                    </p>
                </div>
              </a>
            `
                : ""
            }
          </div>
      `;
      this.carousel.appendChild(review);
    });

    this.addCarouselParameters();
  }

  populateStoreReviews(data) {
    console.log(data);
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 1.33,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      pagination: {
        el: ".reviews__carousel-dots",
        clickable: true
      },
      spaceBetween: 12,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      breakpoints: {
        560: {
          slidesPerView: 2.2
        },
        860: {
          slidesPerView: 3.2
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 4,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          navigation: {
            nextEl: ".reviews__carousel-nav .carousel-navigation__next",
            prevEl: ".reviews__carousel-nav .carousel-navigation__prev"
          }
        }
      }
    });

    this.carousel.initialize();
  }
}

if (!customElements.get("reviews-carousel")) customElements.define("reviews-carousel", ReviewsCarousel);
